import { render, staticRenderFns } from "./StudentAwardByItemBarChartHorizontal.vue?vue&type=template&id=39a22a58&"
import script from "./StudentAwardByItemBarChartHorizontal.vue?vue&type=script&lang=js&"
export * from "./StudentAwardByItemBarChartHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports